"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const antd_1 = require("complex-component/antd");
const MutipleForm_vue_1 = __importDefault(require("@/components/data/MutipleForm.vue"));
const flow_1 = require("@/config/utils/flow");
exports.default = (0, vue_1.defineComponent)({
    name: 'FlowEdit',
    components: {
        MutipleForm: MutipleForm_vue_1.default,
        ComplexEditForm: antd_1.ComplexEditForm
    },
    props: {
        mainData: {
            type: Object,
            required: true
        },
        flow: {
            type: Object,
            required: true
        },
        payload: {
            type: Object,
            default: () => ({})
        },
        refuse: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        }
    },
    data() {
        return {
            isInit: false,
            currentFlowList: [],
            flowKey: undefined,
            detail: undefined
        };
    },
    computed: {
        isOperating() {
            return this.mainData.$getStatus('operate') === 'ing';
        },
        isStart() {
            return !this.flowKey || this.flowKey === this.flow.getBuild();
        },
        isDisabled() {
            return this.disabled || this.flowKey === this.flow.getEnd();
        }
    },
    methods: {
        init(flowKey, detail) {
            this.isInit = true;
            this.detail = detail;
            this.flowKey = flowKey;
            const editForm = this.$refs['edit-form'];
            // eslint-disable-next-line no-console
            console.log('flowKey', flowKey);
            if (!this.flowKey) {
                editForm.show(this.flow.getBuild(), 'change', this.detail);
            }
            else {
                const flowList = this.flow.getList(this.flowKey);
                const index = flowList.indexOf(this.flowKey);
                this.currentFlowList = flowList.slice(0, index);
                if (this.currentFlowList.length > 0) {
                    this.$refs['mutiple-form'].init();
                }
                editForm.show(this.flowKey, 'change', this.detail);
            }
        },
        onBack(toFrom) {
            this.$emit('back', toFrom);
        },
        onRefuse() {
            (0, flow_1.approval)('refuse', (opinions) => {
                this.mainData.$triggerMethod('refuseItem', [{ applyComment: opinions }, this.payload, this.detail], true).then(() => {
                    this.onBack();
                });
            });
        },
        onReject() {
            (0, flow_1.approval)('reject', (opinions) => {
                this.mainData.$triggerMethod('rejectItem', [{ applyComment: opinions }, this.payload, this.detail], true).then(() => {
                    this.onBack();
                });
            });
        },
        onSave() {
            this.$refs['edit-form'].handle((targetData, originData, type) => {
                if (type === this.flow.getBuild() && !this.flowKey) {
                    this.mainData.$triggerMethod('buildItem', [targetData, this.payload, originData], true).then(() => {
                        this.onBack(true);
                    });
                }
                else {
                    (0, flow_1.approval)('agree', (opinions) => {
                        targetData.applyComment = opinions;
                        this.mainData.$triggerMethod('changeItem', [targetData, this.payload, originData, this.flowKey], true).then(() => {
                            this.onBack();
                        });
                    });
                }
            });
        }
    }
});
